let multiLang = {
    cn: {
        uploadImageSizeTwo: '上传图片不得超过5Mb，请重新选择。',
		uploadFileSizeTen: '文件大小超过10Mb。 请再次上传。',
		uploadFileSizeTwenty: '文件大小超过20Mb。 请再次上传。',
		uploadImageMax: '最多10张图片。',
		errorPdfFormat: '格式错误,请仅上传PDF文件。',
		selectFile: '选择文件',
		selectVideo: '选择视频',
		errorVideoFormat: '格式错误。 请仅上传MP4文件。',
        confirmVotingResult: '确认投票结果',
        cannotBeModified: '确认后无法修改',
        btnConfirm: '确 认',
        btnLater: '稍 后',
        imageCropping: '图片裁剪',
        cropPreview: '裁剪预览',
        btnCancel: '取 消',
        widthdraw: '确认撤回？'
    },
	en: {
        uploadImageSizeTwo: 'Image size exceeds 5M, please re-upload.',
		uploadFileSizeTen: 'File size is over 10Mb. Please upload again.',
		uploadFileSizeTwenty: 'File size is over 20Mb. Please upload again.',
		uploadImageMax: 'Maximum 10 pictures.',
		errorPdfFormat: 'Format incorrect. Please upload PDF files only.',
		selectFile: 'Upload PDF',
		selectVideo: 'Upload video',
		errorVideoFormat: 'Format incorrect. Please upload MP4 files only.',
        confirmVotingResult: 'Confirm the voting result',
        cannotBeModified: 'Cannot be modified after confirmation',
        btnConfirm: 'Confirm',
        btnLater: 'Later',
        imageCropping: 'Crop',
        cropPreview: 'Preview',
        btnCancel: 'Cancel',
        widthdraw: 'Sure to withdraw？'
    }
}

export default function Language() {
    const langCode = $('#lang').val();

    let lang = null;

    switch (langCode) {
        case 'cn': 
            lang = multiLang.cn;
            break;
        case 'en': 
            lang = multiLang.en;
            break;
    }

    return lang;
}